import type { GetArAgingReportResponse } from '@vy/api-definition';
import { getCurrencySymbol } from '@vy/services';
import { isNotNullOrUndefined, vyDate } from '@vy/utils';
import type ExcelJs from 'exceljs';

export function createInvoicesWorksheet(workbook: ExcelJs.Workbook, arAgingReport: GetArAgingReportResponse) {
  const invoicesWorksheet = workbook.addWorksheet('Invoices', {
    properties: {
      defaultColWidth: 24,
    },
    views: [
      {
        zoomScale: 110,
      },
    ],
  });

  invoicesWorksheet.columns = [
    {
      header: 'Invoice Number',
      key: 'invoiceNumber',
    },
    {
      header: 'Customer',
      key: 'customerName',
    },
    {
      header: 'Issue Date',
      key: 'issueDate',
    },
    {
      header: 'Due date',
      key: 'dueDate',
    },
    {
      header: 'Gross Amount',
      key: 'grossAmount',
      width: 30,
      style: {
        numFmt: `${getCurrencySymbol(arAgingReport.settings.currency)}#,##0.00`,
      },
    },
    {
      header: 'Days Outstanding',
      key: 'daysOutstanding',
      width: 30,
      style: {
        numFmt: '#,##0',
      },
    },
  ];

  invoicesWorksheet.autoFilter = 'A1:F1';

  ['A1', 'B1', 'C1', 'D1', 'E1', 'F1'].map((cell) => {
    invoicesWorksheet.getCell(cell).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '46BDC6' },
    };
    invoicesWorksheet.getCell(cell).font = {
      color: { argb: 'FFFFFF' },
    };
    invoicesWorksheet.getCell(cell).alignment = {
      vertical: 'middle',
      horizontal: 'center',
    };
  });

  arAgingReport.summaryBreakdown.forEach(({ invoice, customer, daysOutstanding }) => {
    const newRow = invoicesWorksheet.addRow({
      invoiceNumber: invoice.invoiceNumber,
      customerName: customer.name,
      issueDate: isNotNullOrUndefined(invoice.issuedAt) ? vyDate(invoice.issuedAt).format('D MMMM YYYY') : '',
      dueDate: isNotNullOrUndefined(invoice.dueDate) ? vyDate(invoice.dueDate).format('D MMMM YYYY') : '',
      grossAmount: invoice.revenueBreakdown.total,
      daysOutstanding,
    });

    newRow.getCell(1).value = {
      text: invoice.invoiceNumber,
      hyperlink: `${window.location.origin}/invoices/overview/light/${invoice.id}`,
      tooltip: `Open invoice ${invoice.id.slice(-5)} in Vayu`,
    };

    newRow.getCell(2).value = {
      text: customer.name,
      hyperlink: `${window.location.origin}/customers/${customer.id}`,
      tooltip: `Open ${customer.name} in Vayu`,
    };

    newRow.commit();
  });
}
